/**
 * @flow
 * @relayHash bf1c8e0c923ca13a9820341ecc65bc4f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type srcStoreContentQueryVariables = {||};
export type srcStoreContentQueryResponse = {|
  +storecontent: ?{|
    +banner: ?string,
    +stores: ?$ReadOnlyArray<?{|
      +uid: string,
      +slug: string,
      +name: string,
      +color: ?string,
      +preview: ?{|
        +cover: ?string,
        +title: ?string,
        +address: ?string,
      |},
      +seo: ?{|
        +title: ?string,
        +description: ?string,
      |},
    |}>,
    +products: $ReadOnlyArray<?{|
      +name: ?string,
      +description: ?string,
      +type: ?string,
      +link: ?string,
      +picture: ?string,
    |}>,
    +maincontent: ?{|
      +mainpicture: ?string,
      +maindescription: ?string,
      +mainhighlight: ?string,
      +intro: ?string,
      +footer_product_image: ?string,
    |},
    +seo: ?{|
      +title: ?string,
      +description: ?string,
    |},
    +social: ?{|
      +twitter: ?$ReadOnlyArray<?{|
        +type: ?string,
        +title: ?string,
        +image: ?string,
        +handle: ?string,
        +description: ?string,
      |}>,
      +generic: ?$ReadOnlyArray<?{|
        +title: ?string,
        +image: ?string,
        +description: ?string,
      |}>,
    |},
    +partnercontent: ?$ReadOnlyArray<?{|
      +partnerpicture: ?string,
      +partnertitle: ?string,
      +partnerdescription: ?string,
    |}>,
    +contactevent: ?{|
      +title: ?string,
      +description: ?string,
      +contact: ?string,
    |},
    +contactproduct: ?{|
      +title: ?string,
      +description: ?string,
      +contact: ?string,
    |},
  |}
|};
export type srcStoreContentQuery = {|
  variables: srcStoreContentQueryVariables,
  response: srcStoreContentQueryResponse,
|};
*/


/*
query srcStoreContentQuery {
  storecontent {
    banner
    stores {
      uid
      slug
      name
      color
      preview {
        cover
        title
        address
      }
      seo {
        title
        description
      }
    }
    products {
      name
      description
      type
      link
      picture
    }
    maincontent {
      mainpicture
      maindescription
      mainhighlight
      intro
      footer_product_image
    }
    seo {
      title
      description
    }
    social {
      twitter {
        type
        title
        image
        handle
        description
      }
      generic {
        title
        image
        description
      }
    }
    partnercontent {
      partnerpicture
      partnertitle
      partnerdescription
    }
    contactevent {
      title
      description
      contact
    }
    contactproduct {
      title
      description
      contact
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "seo",
  "storageKey": null,
  "args": null,
  "concreteType": "SEO",
  "plural": false,
  "selections": [
    v1,
    v2
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v6 = [
  v1,
  v2,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "contact",
    "args": null,
    "storageKey": null
  }
],
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "storecontent",
    "storageKey": null,
    "args": null,
    "concreteType": "StoreContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "banner",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "stores",
        "storageKey": null,
        "args": null,
        "concreteType": "Store",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "uid",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "slug",
            "args": null,
            "storageKey": null
          },
          v0,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "color",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "preview",
            "storageKey": null,
            "args": null,
            "concreteType": "StorePreview",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cover",
                "args": null,
                "storageKey": null
              },
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "address",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v3
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "products",
        "storageKey": null,
        "args": null,
        "concreteType": "StoreProduct",
        "plural": true,
        "selections": [
          v0,
          v2,
          v4,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "link",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "maincontent",
        "storageKey": null,
        "args": null,
        "concreteType": "StoreMainContent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "mainpicture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maindescription",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "mainhighlight",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "intro",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "footer_product_image",
            "args": null,
            "storageKey": null
          }
        ]
      },
      v3,
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "social",
        "storageKey": null,
        "args": null,
        "concreteType": "SocialMedia",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "twitter",
            "storageKey": null,
            "args": null,
            "concreteType": "TwtrSlices",
            "plural": true,
            "selections": [
              v4,
              v1,
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "handle",
                "args": null,
                "storageKey": null
              },
              v2
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "generic",
            "storageKey": null,
            "args": null,
            "concreteType": "GenSocialSlices",
            "plural": true,
            "selections": [
              v1,
              v5,
              v2
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "partnercontent",
        "storageKey": null,
        "args": null,
        "concreteType": "StorePartnerContent",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "partnerpicture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "partnertitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "partnerdescription",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contactevent",
        "storageKey": null,
        "args": null,
        "concreteType": "StoreContactEvent",
        "plural": false,
        "selections": v6
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contactproduct",
        "storageKey": null,
        "args": null,
        "concreteType": "StoreContactProduct",
        "plural": false,
        "selections": v6
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcStoreContentQuery",
  "id": null,
  "text": "query srcStoreContentQuery {\n  storecontent {\n    banner\n    stores {\n      uid\n      slug\n      name\n      color\n      preview {\n        cover\n        title\n        address\n      }\n      seo {\n        title\n        description\n      }\n    }\n    products {\n      name\n      description\n      type\n      link\n      picture\n    }\n    maincontent {\n      mainpicture\n      maindescription\n      mainhighlight\n      intro\n      footer_product_image\n    }\n    seo {\n      title\n      description\n    }\n    social {\n      twitter {\n        type\n        title\n        image\n        handle\n        description\n      }\n      generic {\n        title\n        image\n        description\n      }\n    }\n    partnercontent {\n      partnerpicture\n      partnertitle\n      partnerdescription\n    }\n    contactevent {\n      title\n      description\n      contact\n    }\n    contactproduct {\n      title\n      description\n      contact\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcStoreContentQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v7
  },
  "operation": {
    "kind": "Operation",
    "name": "srcStoreContentQuery",
    "argumentDefinitions": [],
    "selections": v7
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9dfb1cffb7e20ab32a0d6cbfe5964915';
module.exports = node;
